import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditCard'
})
export class CreditCardPipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    const numbers = (value || '').replace(/\D/g,'');
    const last = numbers.length;
    const all = numbers.split('');

    let length = 4 > last ? last : 4;
    const first = all.slice(0, length).join('');
    length = 8 > last ? last : 8;
    let second = ' ' + all.slice(4, length).join('');
    length = 12 > last ? last : 12;
    let third = ' ' + all.slice(8, length).join('');
    length = 16 > last ? last : 16;
    let fourth = ' ' + all.slice(12, length).join('');

    if (second === ' ') { second = '' }
    if (third === ' ') { third = '' }
    if (fourth === ' ') { fourth = '' }
  
    const formatted = `${first}${second}${third}${fourth}`;
    return formatted;
  }

}
